// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__L7_3a","tab":"Tabs_tab__bQ1j7"};